// extracted by mini-css-extract-plugin
module.exports = {"link-button":"link-button-component_link-button__1YX-S"};